import { ts } from '_core';

import { StyleFactor } from '@finsera/finsera/dist/resource/risk_model';

export const prepareData = (data: ts.types.widgets.TableData, styleFactors?: Partial<StyleFactor>[]) => {
  const newData = data.map((item) => {
    const newItem = {} as ts.types.widgets.TableData[number];
    Object.keys(item).forEach((key) => {
      if (key.includes('_industry_')) {
        newItem[key.replace('_industry_', '')] = item[key];
      } else if (key.includes('_style_')) {
        let newKey = key.replace('_style_', '');
        newKey = styleFactors?.find((el) => el.handle == newKey)?.name || newKey;
        newItem[newKey] = item[key];
      } else {
        newItem[key] = item[key];
      }
    });
    return newItem;
  });

  return newData;
};
